import { useCallback } from "react"
import { MultiSelectOption } from "../types"

interface UseKeyboardNavigationProps {
  isOpen: boolean
  filteredOptions: MultiSelectOption[]
  focusedIndex: number
  setFocusedIndex: (index: number) => void
  selectFocusedOption: () => void
  closeDropdown: () => void
  removeLastValue: () => void
  searchValue: string
}

export const useKeyboardNavigation = ({
  isOpen,
  filteredOptions,
  focusedIndex,
  setFocusedIndex,
  selectFocusedOption,
  closeDropdown,
  removeLastValue,
  searchValue,
}: UseKeyboardNavigationProps) => {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (!isOpen) {
        // ドロップダウンが閉じている時
        if (e.key === "Backspace" && !searchValue) {
          e.preventDefault()
          removeLastValue()
        }
        return
      }

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault()
          setFocusedIndex(focusedIndex < filteredOptions.length - 1 ? focusedIndex + 1 : 0)
          break

        case "ArrowUp":
          e.preventDefault()
          setFocusedIndex(focusedIndex > 0 ? focusedIndex - 1 : filteredOptions.length - 1)
          break

        case "Enter":
          e.preventDefault()
          if (focusedIndex >= 0) {
            selectFocusedOption()
          }
          break

        case "Escape":
          e.preventDefault()
          closeDropdown()
          break

        case "Tab":
          closeDropdown()
          break
      }
    },
    [
      isOpen,
      filteredOptions.length,
      focusedIndex,
      setFocusedIndex,
      selectFocusedOption,
      closeDropdown,
      removeLastValue,
      searchValue,
    ]
  )

  return {
    handleKeyDown,
  }
}
